export class customEventsNames {
    constructor() {
        this.openModal = 'openModal';
        this.closeModal = 'closeModal';
        this.playVideoInModal = 'playVideoInModal';
        this.playYoutubeVideoInModal = 'playYoutubeVideoInModal';
        this.videoPlayingInModal = 'videoStartedPlayingInModal';
        this.playVimeoInModal = 'playVimeoInModal';
        this.panelClosed = 'panelClosed';
        this.panelOpened = 'panelOpened';
        this.assetMarketMapVisible = 'assetMarketMapVisible';
        this.assetMarketMapHidden = 'assetMarketMapHidden';
        this.videoStartedPlayingInSlider = 'videoStartedPlayingInSlider';
        this.videoStoppedPlayingInSlider = 'videoStoppedPlayingInSlider';
        this.accordionInitialised = 'accordionInitialized';
        this.accordionActivateItemEventName = 'activateAccordionItem';
        this.accordionDeactivateItemEventName = 'deactivateAccordionItem';
        this.accordionDeactivateAllItemsEventName = 'deactivateAllAccordionItems';
    }
};
export default new customEventsNames();